import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import Favorite from '@mui/icons-material/Favorite';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import OrdersBottomModal from './OrdersBottomModal';
import './style/HistoryOfOrders.css';

const API_URL = `${process.env.REACT_APP_API_URL}v1`;
const API_KEY = '12345xxa';

function HistoryOfOrders() {
  const [orders, setOrders] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [mode, setMode] = useState('delivery');
  const [selectedStatus, setSelectedStatus] = useState('Все');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const location = useLocation();

  useEffect(() => {
    fetchOrders();
    fetchStatuses();
    if (location.state && location.state.message) {
      alert(location.state.message);
    }
  }, [location.state]);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_URL}/orders`, {
        headers: { 'x-api-key': API_KEY }
      });
      console.log('Orders response:', response.data);

      // Fetch all order items
      const itemsResponse = await axios.get(`${API_URL}/orderitems`, {
        headers: { 'x-api-key': API_KEY }
      });
      console.log('Order items response:', itemsResponse.data);

      // Fetch products details for each item
      const itemsWithProducts = await Promise.all(itemsResponse.data.map(async (item) => {
        const productResponse = await axios.get(`${API_URL}/products/${item.id_product}`, {
          headers: { 'x-api-key': API_KEY }
        });
        console.log(`Product response for item ${item.id}:`, productResponse.data);
        return { ...item, product: productResponse.data };
      }));

      // Group order items by order id
      const itemsByOrder = itemsWithProducts.reduce((acc, item) => {
        if (!acc[item.id_order]) {
          acc[item.id_order] = [];
        }
        acc[item.id_order].push(item);
        return acc;
      }, {});

      // Attach items to their respective orders
      const ordersWithItems = response.data.map(order => {
        return itemsByOrder[order.id] ? { ...order, items: itemsByOrder[order.id] } : null;
      }).filter(order => order !== null);

      console.log('Orders with items:', ordersWithItems);
      setOrders(ordersWithItems);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const response = await axios.get(`${API_URL}/statuses`, {
        headers: { 'x-api-key': API_KEY }
      });
      console.log('Statuses response:', response.data);
      setStatuses(response.data);
    } catch (error) {
      console.error('Error fetching statuses:', error);
    }
  };

  const openModal = (product) => {
    setSelectedProduct(product);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedProduct(null);
  };

  const filterOrders = () => {
    if (selectedStatus === 'Все') {
      return orders;
    }
    return orders.filter(order => order.status_name === selectedStatus);
  };

  const toggleExpandOrder = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  const getStatusColor = (statusId) => {
    const status = statuses.find(s => s.id === statusId);
    return status ? status.color_code : '#f8f9fa';
  };

  const OrderProductCard = ({ item, openModal }) => {
    const [isFavorite, setIsFavorite] = useState(false);
    const { product, quantity } = item;

    const toggleFavorite = (e) => {
      e.stopPropagation();
      setIsFavorite(!isFavorite);
    };

    return (
      <div className="order-product-card">
        <div className="order-product-img" onClick={() => openModal(product)} style={{
          backgroundImage: `url(${process.env.REACT_APP_IMAGES_URL}/${product.product_photo})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          cursor: 'pointer'
        }}>
          {/* <button onClick={toggleFavorite} className="order-product-favorite-button">
            {isFavorite ? <Favorite color="error" /> : <FavoriteBorder />}
          </button> */}
        </div>
        <div className="order-product-details">
          <span className="order-product-name" title={product.name}>{product.name}</span>
          <div className="order-product-info">
            <span className="order-product-quantity">{`Количество: ${quantity}`}</span>
            <span className="order-product-price">{`Цена: ${product.price} T`}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="historyoforders-content">
      <div className="historyoforders-content-header">
        <div className="historyoforders-content-header-zagolovok">
          <h2 className="historyoforders-zagolovok">Заказы</h2>
        </div>
        <div className="historyoforders-content-header-switch">
          <button
            className={`historyoforders-button-switch ${mode === 'delivery' ? 'selected' : ''}`}
            onClick={() => setMode('delivery')}
          >
            <LocalShippingIcon />
            {mode === 'delivery' && <span>Доставка</span>}
          </button>
          <button
            className={`historyoforders-button-switch ${mode === 'pickup' ? 'selected' : ''}`}
            onClick={() => setMode('pickup')}
          >
            <StoreIcon />
            {mode === 'pickup' && <span>Самовывоз</span>}
          </button>
        </div>
      </div>
      <div className="historyoforders-content-status">
        <div className="historyoforders-content-status-basic">
          <div>
            <div className="historyoforders-content-status-basic-switch">
              <button
                className={`historyoforders-status-button ${selectedStatus === 'Все' ? 'selected' : ''}`}
                onClick={() => setSelectedStatus('Все')}
              >
                Все
              </button>
              {statuses.map(status => (
                <button
                  key={status.id}
                  className={`historyoforders-status-button ${selectedStatus === status.name ? 'selected' : ''}`}
                  onClick={() => setSelectedStatus(status.name)}
                >
                  {status.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      {filterOrders().map(order => (
        <div key={order.id} className={`historyoforders-content-basic ${expandedOrder === order.id ? 'expanded' : ''}`}>
          <div className="historyoforders-content-basic-1">
            <div className="historyoforders-content-basic-text-1">
              <h2 className="historyoforders-content-basic-zagolovok">
                {order.client_name}
              </h2>
              <div className="historyoforders-content-basic-status" style={{ backgroundColor: getStatusColor(order.id_status) }}>
                {order.status_name}
              </div>
            </div>
            <div className="historyoforders-content-basic-text-2">
              <span className="historyoforders-content-basic-textday">
                Доставим ({new Date(order.delivery_date).toLocaleDateString()})
              </span>
              <span className="historyoforders-content-basic-text-time">
                с 12:00 до 14:00
              </span>
            </div>
            <div className="historyoforders-content-basic-text-3">
              <span className="historyoforders-content-basic-text-delivery">
                Адрес доставки:
              </span>
              <span className="historyoforders-content-basic-text-address">
                {order.delivery_address}
              </span>
            </div>
          </div>
          <div className="historyoforders-content-basic-2">
            <div className="historyoforders-content-tovarlist">
              {order.items.map(item => (
                item.product && (
                  <OrderProductCard key={item.id} item={item} openModal={openModal} />
                )
              ))}
            </div>
          </div>
          <div className="historyoforders-content-basic-3">
            <button className="historyoforders-content-basic-knopka-1" onClick={() => toggleExpandOrder(order.id)}>
              {expandedOrder === order.id ? 'Скрыть' : 'Все'}
            </button>
            <div className="historyoforders-content-basic-total">
              {`Итоговая цена: ${order.total_amount} T`}
            </div>
          </div>
        </div>
      ))}
      <OrdersBottomModal isOpen={isOpen} onClose={closeModal} product={selectedProduct} />
    </div>
  );
}

export default HistoryOfOrders;
